var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.52381C0.5 4.12932 0.82671 3.80952 1.22973 3.80952H6.01787C6.02437 2.9683 6.11554 1.81504 6.95037 1.01668C7.60737 0.388386 8.50808 0 9.49999 0C10.4919 0 11.3926 0.388385 12.0496 1.01668C12.8844 1.81504 12.9756 2.9683 12.9821 3.80952H17.7703C18.1733 3.80952 18.5 4.12932 18.5 4.52381C18.5 4.9183 18.1733 5.2381 17.7703 5.2381H1.22973C0.82671 5.2381 0.5 4.9183 0.5 4.52381Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0956 20H9.9044C12.6871 20 14.0785 20 14.9831 19.1141C15.8878 18.2281 15.9803 16.7749 16.1654 13.8685L16.4321 9.6806C16.5326 8.10361 16.5828 7.31511 16.1289 6.81545C15.6751 6.31579 14.9087 6.31579 13.376 6.31579H5.62404C4.09127 6.31579 3.32488 6.31579 2.87105 6.81545C2.41722 7.31511 2.46744 8.10361 2.56788 9.6806L2.83459 13.8685C3.0197 16.7749 3.11225 18.2281 4.01689 19.1141C4.92153 20 6.31289 20 9.0956 20ZM7.74628 10.1885C7.70506 9.75463 7.33753 9.43809 6.92537 9.48148C6.51321 9.52486 6.21251 9.91174 6.25372 10.3456L6.75372 15.6087C6.79494 16.0426 7.16247 16.3591 7.57463 16.3157C7.98678 16.2724 8.28749 15.8855 8.24628 15.4516L7.74628 10.1885ZM12.0746 9.48148C12.4868 9.52486 12.7875 9.91174 12.7463 10.3456L12.2463 15.6087C12.2051 16.0426 11.8375 16.3591 11.4254 16.3157C11.0132 16.2724 10.7125 15.8855 10.7537 15.4516L11.2537 10.1885C11.2949 9.75463 11.6625 9.43809 12.0746 9.48148Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBin);
export default __webpack_public_path__ + "static/media/red-bin.1e7d3ea75ce551fd1dd78124fb31dd88.svg";
export { ForwardRef as ReactComponent };